import { render, staticRenderFns } from "./BrokerCommissionFilter.vue?vue&type=template&id=065f5c84&scoped=true"
import script from "./BrokerCommissionFilter.vue?vue&type=script&lang=js"
export * from "./BrokerCommissionFilter.vue?vue&type=script&lang=js"
import style0 from "./BrokerCommissionFilter.vue?vue&type=style&index=0&id=065f5c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065f5c84",
  null
  
)

export default component.exports